import React, {Component} from "react";
import {findDOMNode} from "react-dom";
import {boundMethod} from "autobind-decorator";
import typeUtils from "@legacy/helpers/utils/typeUtils";
import constants from '@legacy/helpers/constants.js.es6';
import {FormControl, InputGroup} from "react-bootstrap";
import Reload from "@legacy/components/common/CompanySwitcher/Reload/index";

const { key } = constants;

/**
 * SUBCOMPONENT: Primary overlay component for VST Company Switcher
 * @class CompanySwitcherOverlay
 */
export default class CompanySwitcherOverlay extends Component {

    _timout = 0;
    FilterInput = null;
    HTMLInputElement = null;

    componentDidMount() {
        this.HTMLInputElement = findDOMNode(this.FilterInput);
    }

    componentDidUpdate(prevProps){
        const currentlyOpen = this.props.open;
        const { open } = prevProps;

        if(!open && currentlyOpen === true){
            setTimeout(() => {
                this.HTMLInputElement?.focus();
            }, 60);
        }
    }

    @boundMethod
    _onKeyDown(e){
        const { toggleButton } = this.props;
        const _key = e.which || e.keyCode;
        const _button = typeUtils.isFunction(toggleButton) ? toggleButton() : null;

        clearTimeout(this._timeout);

        switch(_key){
            case key.DOWNARROW:
                this._focusNext();
                e.preventDefault();
                break;

            case key.UPARROW:
                this._focusPrev();
                e.preventDefault();
                break;

            case key.ESC:
                _button?.click();
                break;

            case key.TAB:
                _button?.click();
                break;

            default:
                break;
        }
    }

    @boundMethod
    _onFilterTextChange(e){
        const { filter, filterCompanies } = this.props;
        const _value = e.target.value;

        clearTimeout(this._timeout);

        this._timeout = setTimeout(() => {
            filterCompanies(_value, filter);
        }, 200);
    }

    @boundMethod
    _getFocusableMenuItems(){
        const node = findDOMNode(this);
        if(!node){
            return [];
        }

        return Array.from(node.querySelectorAll('[tabIndex="-1"]'));
    }

    @boundMethod
    _getFocusableItemsAndActiveIndex(){
        const items = this._getFocusableMenuItems();
        const activeIndex = items.indexOf(document.activeElement);

        return { items, activeIndex }
    }

    @boundMethod
    _focusNext(){
        const { items, activeIndex } = this._getFocusableItemsAndActiveIndex();

        if(items.length === 0){
            return;
        }

        const nextIndex = (activeIndex === items.length - 1) ? 0 : activeIndex + 1;
        items[nextIndex].focus();
    }

    @boundMethod
    _focusPrev(){
        const { items, activeIndex } = this._getFocusableItemsAndActiveIndex();

        if(items.length === 0){
            return;
        }

        const prevIndex = (activeIndex === 0) ? items.length - 1 : activeIndex - 1;
        items[prevIndex].focus();
    }

    render(){
        const { children, fetchCompanies, toggleButton } = this.props;

        return (
            <div className="vst-user__company-select__overlay dropdown-menu dropdown-menu-right">
                <section>
                    <header>
                        <a className="company-select__overlay__toggle-button"
                           href="#closeCompanySwitcherOverlay"
                           onClick={ (e) => { e && e.preventDefault(); toggleButton().click(); }}>
                            <i className="fa fa-chevron-down" />
                        </a>
                        Select Company to Act As
                    </header>
                </section>
                <ul className="vst-user__company-select__list-container" onKeyDown={ this._onKeyDown }>
                    <li>
                        <InputGroup>
                            <FormControl
                                ref={(c) => { if(c !== null){ this.FilterInput = c; } }}
                                type="text"
                                id="vstUserCompanyFilterInputField"
                                placeholder="<Search Companies>"
                                onKeyUp={ this._onFilterTextChange }
                                autoCorrect="off"
                                autoCapitalize="off"
                                spellCheck="false"
                            />
                            <InputGroup.Addon>
                                <i className="fa fa-search" />
                            </InputGroup.Addon>
                        </InputGroup>
                    </li>
                    <Reload
                        fetchCompanies={fetchCompanies}
                    />
                    <li data-bl-id="vstCompanySwitcher_companiesList">
                        <ul className="vst-user__company-select__list-items-container">
                            { children }
                        </ul>
                    </li>
                </ul>
            </div>
        );
    }
}
